import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import LegalPage from "../pages/public/LegalPage";
import TestimonialsPage from "../pages/public/TestimonialsPage";
import LoginPage from "../pages/auth/login/page";
import RegisterPage from "../pages/auth/register/page";
import LoginClientPage from "../pages/auth/login-client/page";
import RegisterClientPage from "../pages/auth/register-client/page";
import ForgotPasswordPage from "../pages/auth/forgot-password/page";
import ResetPasswordPage from "../pages/auth/reset-password/page";
import ClientDashboardPage from "../pages/client/dashboard/page";
import ClientScanPage from "../pages/client/scan/page";
import ClientDocumentsPage from "../pages/client/documents/page";
import ClientDocumentDetailPage from "../pages/client/documents/detail/page";
import ClientMissionDetailPage from "../pages/client/dashboard/missions/detail/page";
import ClientAppHost from "../pages/client/apps/ClientAppHost";
import DashboardPage from "../pages/dashboard/page";
import DashboardLayout from "../components/feature/DashboardLayout";
import ProductsPage from "../pages/dashboard/products/page";
import NewProductPage from "../pages/dashboard/products/new/page";
import EditProductPage from "../pages/dashboard/products/edit/page";
import StockPage from "../pages/dashboard/products/stock/page";
import ServicesPage from "../pages/dashboard/services/page";
import NewServicePage from "../pages/dashboard/services/new/page";
import EditServicePage from "../pages/dashboard/services/edit/page";
import PortfolioPage from "../pages/dashboard/services/portfolio/page";
import NewPortfolioPage from "../pages/dashboard/services/portfolio/new/page";
import PartenairesPage from "../pages/dashboard/services/partenaires/page";
import EquipePage from "../pages/dashboard/services/equipe/page";
import UsersPage from "../pages/dashboard/services/users/page";
import CaissePage from "../pages/dashboard/caisse/page";
import OrdersPage from "../pages/dashboard/orders/page";
import NewOrderPage from "../pages/dashboard/orders/new/page";
import CustomersPage from "../pages/dashboard/customers/page";
import MerchantMessagesPage from "../pages/dashboard/messages/page";
import PaymentsPage from "../pages/dashboard/payments/page";
import WalletPage from "../pages/dashboard/wallet/page";
import StorePage from "../pages/dashboard/store/page";
import MyLinksStatsPage from "../pages/dashboard/mylinks-stats/page";
import SiteContentPage from "../pages/dashboard/site-content/page";
import BannersPage from "../pages/dashboard/banners/page";
import CustomPagesPage from "../pages/dashboard/custom-pages/page";
import HomeBlocksPage from "../pages/dashboard/home-blocks/page";
import MonSitewebPage from "../pages/dashboard/mon-siteweb/page";
import RestaurantDashboardPage from "../pages/dashboard/restaurant/page";
import DashboardCorePage from "../pages/dashboard/core/page";
import DashboardUsersPage from "../pages/dashboard/users/page";
import DashboardJournalPage from "../pages/dashboard/journal/page";
import DashboardSoclePage from "../pages/dashboard/socle/page";
import MediaPage from "../pages/dashboard/media/page";
import AnalyticsPage from "../pages/dashboard/analytics/page";
import SettingsPage from "../pages/dashboard/settings/page";
import AppStorePage from "../pages/dashboard/appstore/page";
import ThemeStorePage from "../pages/dashboard/themestore/page";
import ThemeBlocksPage from "../pages/dashboard/theme-blocks/page";
import AppsManagementPage from "../pages/dashboard/apps/page";
import AnalyticsAdvancedPage from "../pages/dashboard/apps/analytics-advanced/page";
import CustomersManagerPage from "../pages/dashboard/apps/customers-manager/page";
import CustomerDetailPage from "../pages/dashboard/apps/customers-manager/detail/page";
import WhatsAppButtonPage from "../pages/dashboard/apps/whatsapp-button/page";
import AIShopperPage from "../pages/dashboard/apps/ai-shopper/page";
import CustomerSupportPage from "../pages/dashboard/apps/customer-support/page";
import FacebookPixelPage from "../pages/dashboard/apps/facebook-pixel/page";
import IAReportingPage from "../pages/dashboard/apps/ia-reporting/page";
import MaFidelitePage from "../pages/dashboard/apps/ma-fidelite/page";
import FideliteRecompensesPage from "../pages/dashboard/apps/fidelite-recompenses/page";
import SeoOptimizerPage from "../pages/dashboard/apps/seo-optimizer/page";
import ChatLivePage from "../pages/dashboard/apps/chat-live/page";
import EmailMarketingPage from "../pages/dashboard/apps/email-marketing/page";
import GestionStockPage from "../pages/dashboard/apps/gestion-stock/page";
import ReseauxSociauxPage from "../pages/dashboard/apps/reseaux-sociaux/page";
import SauvegardeAutoPage from "../pages/dashboard/apps/sauvegarde-auto/page";
import AnalyticsProPage from "../pages/dashboard/apps/analytics-pro/page";
import MonAssistantPage from "../pages/dashboard/apps/mon-assistant/page";
import PayPalPage from "../pages/dashboard/apps/paypal/page";
import FileManagerPage from "../pages/dashboard/apps/file-manager/page";
import DocumentsPage from "../pages/dashboard/apps/documents/page";
import DocumentDetailPage from "../pages/dashboard/apps/documents/detail/page";
import FormsAppPage from "../pages/dashboard/apps/forms/page";
import FormBuilderPage from "../pages/dashboard/apps/forms/new/page";
import FormResponsesPage from "../pages/dashboard/apps/forms/responses/page";
import ZCalendarPage from "../pages/dashboard/apps/zcalendar/page";
import ZifekBIPage from "../pages/dashboard/apps/zifekbi/page";
import GestionProPage from "../pages/dashboard/apps/gestionpro/page";
import GestionProDetailPage from "../pages/dashboard/apps/gestionpro/detail/page";
import ZCallPage from "../pages/dashboard/apps/zcall/page";
import FormationAppPage from "../pages/dashboard/apps/formation/page";
import FormationDetailPage from "../pages/dashboard/apps/formation/detail/page";
import HebergementPage from "../pages/dashboard/apps/hebergement/page";
import ContentStudioHomePage from "../pages/dashboard/apps/content-studio/page";
import ContentStudioProjectPage from "../pages/dashboard/apps/content-studio/project/page";
import ContentStudioMediaPage from "../pages/dashboard/apps/content-studio/media/page";
import ContentStudioCalendarPage from "../pages/dashboard/apps/content-studio/calendar/page";
import ContentStudioSeriesPage from "../pages/dashboard/apps/content-studio/series/page";
import ContentStudioVoicePage from "../pages/dashboard/apps/content-studio/voice/page";
import ZStudioHomePage from "../pages/dashboard/apps/zstudio/page";
import ZStudioWizardPage from "../pages/dashboard/apps/zstudio/wizard/page";
import ZStudioCreationsPage from "../pages/dashboard/apps/zstudio/creations/page";
import ZStudioHistoryPage from "../pages/dashboard/apps/zstudio/history/page";
import ZStudioTryOnPage from "../pages/dashboard/apps/zstudio/tryon/page";
import ZStudioEditPage from "../pages/dashboard/apps/zstudio/edit/page";
import ZStudioLookbookPage from "../pages/dashboard/apps/zstudio/lookbook/page";
import ZStudioAssistantPage from "../pages/dashboard/apps/zstudio/assistant/page";
import ZStudioQrPage from "../pages/dashboard/apps/zstudio/qr/page";
import ZStudioProjectsPage from "../pages/dashboard/apps/zstudio/projects/page";
import ZStudioCampaignsPage from "../pages/dashboard/apps/zstudio/campaigns/page";
import MarketplaceAdminPage from "../pages/dashboard/marketplace/page";
import RevendeurPage from "../pages/dashboard/revendeur/page";
import DashboardAbonnementPage from "../pages/dashboard/abonnement/page";
import DashboardBesoinsPage from "../pages/dashboard/besoins/page";
import DashboardMissionsPage from "../pages/dashboard/missions/page";
import MissionDetailPage from "../pages/dashboard/missions/detail/page";
import MerchantBlogPage from "../pages/dashboard/blog/page";
import DashboardEventsPage from "../pages/dashboard/events/page";
import DashboardDayActivityPage from "../pages/dashboard/activity/page";
import MissionsPage from "../pages/missions/page";
import MissionsCampagnesPage from "../pages/public/MissionsCampagnesPage";
import DashboardChoisirAbonnementPage from "../pages/dashboard/abonnement/choisir/page";
import DashboardStoragePage from "../pages/dashboard/storage/page";
import DynamicAppPage from "../pages/dashboard/app/dynamic/page";
import SuperAdminLayout from "../components/feature/SuperAdminLayout";
import SuperAdminDashboard from "../pages/superadmin/page";
import SuperAdminStats from "../pages/superadmin/stats/page";
import SuperAdminUsers from "../pages/superadmin/users/page";
import SuperAdminThemes from "../pages/superadmin/themes/page";
import ThemeGeneratePage from "../pages/superadmin/themes/generate/page";
import ThemeCategoriesPage from "../pages/superadmin/themes/categories/page";
import ThemeReferenceFilesPage from "../pages/superadmin/themes/references/page";
import SuperAdminApps from "../pages/superadmin/apps/page";
import AppBuilderPage from "../pages/superadmin/apps/builder/page";
import SuperAdminLogs from "../pages/superadmin/logs/page";
import SuperAdminSettings from "../pages/superadmin/settings/page";
import SuperAdminPwaPage from "../pages/superadmin/pwa/page";
import SuperAdminTeamPage from "../pages/superadmin/team/page";
import SuperAdminActivityPage from "../pages/superadmin/activity/page";
import SuperAdminHomepage from "../pages/superadmin/homepage/page";
import SuperAdminStorage from "../pages/superadmin/storage/page";
import ExchangeRatesPage from "../pages/superadmin/rates/page";
import TranslationsPage from "../pages/superadmin/translations/page";
import SuperAdminSupport from "../pages/superadmin/support/page";
import SuperAdminDomains from "../pages/superadmin/domains/page";
import SuperAdminTestimonials from "../pages/superadmin/temoignages/page";
import SuperAdminFormations from "../pages/superadmin/formations/page";
import SuperAdminFormationDetail from "../pages/superadmin/formations/detail/page";
import SuperAdminAiUsage from "../pages/superadmin/ai-usage/page";
import SuperAdminDatabase from "../pages/superadmin/database/page";
import SuperAdminAccountTypes from "../pages/superadmin/account-types/page";
import SuperAdminReseaux from "../pages/superadmin/reseaux/page";
import SuperAdminParrainage from "../pages/superadmin/parrainage/page";
import SuperAdminSubscriptions from "../pages/superadmin/subscriptions/page";
import SuperAdminPayments from "../pages/superadmin/payments/page";
import SuperAdminWithdrawals from "../pages/superadmin/withdrawals/page";
import SuperAdminCommercePayments from "../pages/superadmin/commerce-payments/page";
import FeexPayWebhookPage from "../pages/superadmin/webhooks/feexpay/page";
import SuperAdminPlans from "../pages/superadmin/plans/page";
import SuperAdminCore from "../pages/superadmin/core/page";
import ThemeDevPage from "../pages/developpeur/page";
import ProduitsPublic from "../pages/public/ProduitsPage";
import RecherchePublic from "../pages/public/RecherchePage";
import HebergementsPage from "../pages/public/HebergementsPage";
import DetailHebergementPage from "../pages/public/DetailHebergementPage";
import DetailProduitPage from "../pages/public/DetailProduitPage";
import DetailAnnoncePage from "../pages/public/DetailAnnoncePage";
import ServicesPublic from "../pages/public/ServicesPage";
import EventsPage from "../pages/public/EventsPage";
import DetailEventPage from "../pages/public/DetailEventPage";
import PartenairesPublic from "../pages/public/PartenairesPage";
import PortfolioPublic from "../pages/public/PortfolioPage";
import EquipePublic from "../pages/public/EquipePage";
import PublicFormPage from "../pages/public/FormPage";
import BookingPage from "../pages/public/BookingPage";
import BusinessProfilePage from "../pages/public/BusinessProfilePage";
import ZCallRoomPage from "../pages/public/ZCallRoomPage";
import PartagePage from "../pages/public/PartagePage";
import DocumentPreviewPage from "../pages/public/DocumentPreviewPage";
import LookbookPage from "../pages/public/LookbookPage";
import PlanningPage from "../pages/client/dashboard/planning/page";
import AbonnementPage from "../pages/AbonnementPage";
import CreditPortalPage from "../pages/credit/page";
import CreditJoinPage from "../pages/credit/join/page";
import CreditPage from "../pages/dashboard/credit/page";
import CreditCustomerPage from "../pages/dashboard/credit/customer/page";
import FinanceLayout from "../pages/dashboard/finance/FinanceLayout";
import FinanceOverviewPage from "../pages/dashboard/finance/page";
import FinanceRevenusPage from "../pages/dashboard/finance/revenus/page";
import FinanceDepensesPage from "../pages/dashboard/finance/depenses/page";
import FinanceTresoreriePage from "../pages/dashboard/finance/tresorerie/page";
import FinanceFacturesPage from "../pages/dashboard/finance/factures/page";
import NewInvoicePage from "../pages/dashboard/finance/factures/nouvelle/page";
import FinanceDevisPage from "../pages/dashboard/finance/devis/page";
import NewQuotePage from "../pages/dashboard/finance/devis/nouvelle/page";
import FinanceClientsPage from "../pages/dashboard/finance/clients/page";
import FinanceCreditPage from "../pages/dashboard/finance/credit/page";
import FinanceFournisseursPage from "../pages/dashboard/finance/fournisseurs/page";
import FinanceRapportsPage from "../pages/dashboard/finance/rapports/page";
import FinanceAiPage from "../pages/dashboard/finance/ai/page";
import FinanceParametresPage from "../pages/dashboard/finance/parametres/page";
import PaymentReturnPage from "../pages/paiement/retour/page";
import BlogPage from "../pages/public/BlogPage";
import BlogArticlePage from "../pages/public/BlogArticlePage";
import DocumentationPage from "../pages/public/DocumentationPage";
import ApiPage from "../pages/public/ApiPage";
import CommunityPage from "../pages/public/CommunityPage";
import StatusPage from "../pages/public/StatusPage";
import SuperAdminBlogPage from "../pages/superadmin/blog/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/confidentialite",
    element: <LegalPage doc="confidentialite" />,
  },
  {
    path: "/conditions-utilisation",
    element: <LegalPage doc="conditions" />,
  },
  {
    path: "/temoignages",
    element: <TestimonialsPage />,
  },
  {
    path: "/blog",
    element: <BlogPage />,
  },
  {
    path: "/blog/:slug",
    element: <BlogArticlePage />,
  },
  {
    path: "/documentation",
    element: <DocumentationPage />,
  },
  {
    path: "/api",
    element: <ApiPage />,
  },
  {
    path: "/communaute",
    element: <CommunityPage />,
  },
  {
    path: "/status",
    element: <StatusPage />,
  },
  // ── Accès via domaine personnalisé ──────────────────────────
  // https://nomdedomaine.com/admin  → dashboard du marchand
  // https://nomdedomaine.com/client → espace client
  // https://nomdedomaine.com/reservation → page de réservation (calendrier)
  {
    path: "/admin",
    element: <Navigate to="/dashboard" replace />,
  },
  {
    path: "/admin/*",
    element: <Navigate to="/dashboard" replace />,
  },
  {
    path: "/client",
    element: <Navigate to="/mon-compte" replace />,
  },
  {
    path: "/client/*",
    element: <Navigate to="/mon-compte" replace />,
  },
  {
    path: "/reservation",
    element: <Navigate to="/booking" replace />,
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/register",
    element: <RegisterPage />,
  },
  {
    path: "/login-client",
    element: <LoginClientPage />,
  },
  {
    path: "/register-client",
    element: <RegisterClientPage />,
  },
  {
    path: "/mot-de-passe-oublie",
    element: <ForgotPasswordPage />,
  },
  {
    path: "/reinitialiser-mot-de-passe",
    element: <ResetPasswordPage />,
  },
  {
    path: "/mon-compte",
    element: <ClientDashboardPage />,
  },
  {
    path: "/mon-compte/:tab",
    element: <ClientDashboardPage />,
  },
  {
    path: "/mon-compte/apps/:slug",
    element: <ClientAppHost />,
  },
  {
    path: "/mon-compte/documents",
    element: <ClientDocumentsPage />,
  },
  {
    path: "/mon-compte/documents/:id",
    element: <ClientDocumentDetailPage />,
  },
  {
    path: "/mon-compte/scan",
    element: <ClientScanPage />,
  },
  {
    path: "/mon-compte/missions/:id",
    element: <ClientMissionDetailPage />,
  },
  {
    path: "/mon-planning",
    element: <PlanningPage />,
  },
  {
    path: "/abonnement",
    element: <AbonnementPage />,
  },
  // ── Retour de paiement FeexPay (page hébergée / lien de retour) ──
  // ?type=abonnement → espace commerçant · ?type=achat → espace client
  {
    path: "/paiement/retour",
    element: <PaymentReturnPage />,
  },
  {
    path: "/paiement-retour",
    element: <PaymentReturnPage />,
  },
  {
    path: "/retour-paiement",
    element: <PaymentReturnPage />,
  },
  {
    path: "/credit/join",
    element: <CreditJoinPage />,
  },
  {
    path: "/credit",
    element: <CreditPortalPage />,
  },
  {
    path: "/produits",
    element: <ProduitsPublic />,
  },
  {
    path: "/recherche",
    element: <RecherchePublic />,
  },
  {
    path: "/hebergements",
    element: <HebergementsPage />,
  },
  {
    path: "/hebergement/:id",
    element: <DetailHebergementPage />,
  },
  {
    path: "/product/:id",
    element: <DetailProduitPage />,
  },
  {
    path: "/produit/:id",
    element: <DetailAnnoncePage />,
  },
  {
    path: "/annonce/:id",
    element: <DetailAnnoncePage />,
  },
  {
    path: "/services",
    element: <ServicesPublic />,
  },
  {
    path: "/business/:slug",
    element: <BusinessProfilePage />,
  },
  {
    path: "/service/:id",
    element: <DetailAnnoncePage />,
  },
  // ── Agenda public du commerce (page « Événements » + détail) ──
  {
    path: "/events",
    element: <EventsPage />,
  },
  {
    path: "/events/:id",
    element: <DetailEventPage />,
  },
  {
    path: "/evenements",
    element: <EventsPage />,
  },
  {
    path: "/evenements/:id",
    element: <DetailEventPage />,
  },
  {
    path: "/partenaires",
    element: <PartenairesPublic />,
  },
  {
    path: "/portfolio",
    element: <PortfolioPublic />,
  },
  {
    path: "/equipe",
    element: <EquipePublic />,
  },
  {
    path: "/forms/:id",
    element: <PublicFormPage />,
  },
  {
    path: "/booking",
    element: <BookingPage />,
  },
  {
    path: "/booking/:serviceId",
    element: <BookingPage />,
  },
  {
    path: "/call/:roomId",
    element: <ZCallRoomPage />,
  },
  {
    path: "/zcall/:slug",
    element: <ZCallRoomPage />,
  },
  {
    path: "/partage/:token",
    element: <PartagePage />,
  },
  // ── Consultation publique d'un document partagé (sans compte Zifek) ──
  // Formats acceptés : /preview/<token> et les anciens liens
  // /preview/<tenant>/<id>/partage/<token> (le token est le dernier segment).
  {
    path: "/preview",
    element: <DocumentPreviewPage />,
  },
  {
    path: "/preview/*",
    element: <DocumentPreviewPage />,
  },
  {
    path: "/lookbook/:outfitId",
    element: <LookbookPage />,
  },
  {
    path: "/missions",
    element: <MissionsPage />,
  },
  {
    path: "/missions-campagnes",
    element: <MissionsCampagnesPage />,
  },
  {
    path: "/dashboard",
    element: <DashboardLayout />,
    children: [
      { index: true, element: <DashboardPage /> },
      { path: "restaurant", element: <RestaurantDashboardPage /> },
      { path: "core", element: <DashboardCorePage /> },
      { path: "users", element: <DashboardUsersPage /> },
      { path: "journal", element: <DashboardJournalPage /> },
      { path: "socle", element: <DashboardSoclePage /> },
      { path: "caisse", element: <CaissePage /> },
      { path: "products", element: <ProductsPage /> },
      { path: "products/new", element: <NewProductPage /> },
      { path: "products/:id/edit", element: <EditProductPage /> },
      { path: "products/stock", element: <StockPage /> },
      { path: "services", element: <ServicesPage /> },
      { path: "services/new", element: <NewServicePage /> },
      { path: "services/:id/edit", element: <EditServicePage /> },
      { path: "services/portfolio", element: <PortfolioPage /> },
      { path: "services/portfolio/new", element: <NewPortfolioPage /> },
      { path: "services/partenaires", element: <PartenairesPage /> },
      { path: "services/equipe", element: <EquipePage /> },
      { path: "services/users", element: <UsersPage /> },
      { path: "orders/new", element: <NewOrderPage /> },
      { path: "orders", element: <OrdersPage /> },
      { path: "customers/:clientId", element: <CustomerDetailPage /> },
      { path: "customers", element: <CustomersPage /> },
      { path: "customer/credit/:id", element: <CreditCustomerPage /> },
      { path: "customer/:clientId", element: <CustomerDetailPage /> },
      { path: "messages", element: <MerchantMessagesPage /> },
      { path: "credit", element: <CreditPage /> },
      { path: "credit/customer/:id", element: <CreditCustomerPage /> },
      {
        path: "finance",
        element: <FinanceLayout />,
        children: [
          { index: true, element: <FinanceOverviewPage /> },
          { path: "revenus", element: <FinanceRevenusPage /> },
          { path: "depenses", element: <FinanceDepensesPage /> },
          { path: "tresorerie", element: <FinanceTresoreriePage /> },
          { path: "factures", element: <FinanceFacturesPage /> },
          { path: "factures/nouvelle", element: <NewInvoicePage /> },
          { path: "devis", element: <FinanceDevisPage /> },
          { path: "devis/nouvelle", element: <NewQuotePage /> },
          { path: "clients", element: <FinanceClientsPage /> },
          { path: "credit", element: <FinanceCreditPage /> },
          { path: "fournisseurs", element: <FinanceFournisseursPage /> },
          { path: "rapports", element: <FinanceRapportsPage /> },
          { path: "parametres", element: <FinanceParametresPage /> },
          { path: "ai", element: <FinanceAiPage /> },
        ],
      },
      { path: "payments", element: <PaymentsPage /> },
      { path: "wallet", element: <WalletPage /> },
      { path: "revendeur", element: <RevendeurPage /> },
      { path: "abonnement", element: <DashboardAbonnementPage /> },
      { path: "besoins", element: <DashboardBesoinsPage /> },
      { path: "missions", element: <DashboardMissionsPage /> },
      { path: "missions/:id", element: <MissionDetailPage /> },
      { path: "blog", element: <MerchantBlogPage /> },
      { path: "events", element: <DashboardEventsPage /> },
      { path: "activite", element: <DashboardDayActivityPage /> },
      { path: "abonnement/choisir", element: <DashboardChoisirAbonnementPage /> },
      { path: "store", element: <StorePage /> },
      { path: "mylinks-stats", element: <MyLinksStatsPage /> },
      { path: "site-content", element: <SiteContentPage /> },
      { path: "banners", element: <BannersPage /> },
      { path: "custom-pages", element: <CustomPagesPage /> },
      { path: "home-blocks", element: <HomeBlocksPage /> },
      { path: "mon-siteweb", element: <MonSitewebPage /> },
      { path: "media", element: <MediaPage /> },
      { path: "analytics", element: <AnalyticsPage /> },
      { path: "settings", element: <SettingsPage /> },
      { path: "appstore", element: <AppStorePage /> },
      { path: "storage", element: <DashboardStoragePage /> },
      { path: "themestore", element: <ThemeStorePage /> },
      { path: "theme-blocks", element: <ThemeBlocksPage /> },
      { path: "apps", element: <AppsManagementPage /> },
      { path: "analytics-advanced", element: <AnalyticsAdvancedPage /> },
      { path: "customers-manager/:customerId", element: <CustomerDetailPage /> },
      { path: "customers-manager", element: <CustomersManagerPage /> },
      { path: "whatsapp-button", element: <WhatsAppButtonPage /> },
      { path: "ai-shopper", element: <AIShopperPage /> },
      { path: "customer-support", element: <CustomerSupportPage /> },
      { path: "facebook-pixel", element: <FacebookPixelPage /> },
      { path: "ia-reporting", element: <IAReportingPage /> },
      { path: "ma-fidelite", element: <MaFidelitePage /> },
      { path: "fidelite-recompenses", element: <FideliteRecompensesPage /> },
      { path: "seo-optimizer", element: <SeoOptimizerPage /> },
      { path: "chat-live", element: <ChatLivePage /> },
      { path: "email-marketing", element: <EmailMarketingPage /> },
      { path: "gestion-stock", element: <GestionStockPage /> },
      { path: "reseaux-sociaux", element: <ReseauxSociauxPage /> },
      { path: "sauvegarde-auto", element: <SauvegardeAutoPage /> },
      { path: "analytics-pro", element: <AnalyticsProPage /> },
      { path: "mon-assistant", element: <MonAssistantPage /> },
      { path: "paypal", element: <PayPalPage /> },
      { path: "file-manager", element: <FileManagerPage /> },
      { path: "documents", element: <DocumentsPage /> },
      { path: "documents/:id", element: <DocumentDetailPage /> },
      { path: "forms", element: <FormsAppPage /> },
      { path: "forms/new", element: <FormBuilderPage /> },
      { path: "forms/:id/edit", element: <FormBuilderPage /> },
      { path: "forms/:id/responses", element: <FormResponsesPage /> },
      { path: "zcalendar", element: <ZCalendarPage /> },
      { path: "zifekbi", element: <ZifekBIPage /> },
      { path: "gestionpro", element: <GestionProPage /> },
      { path: "gestionpro/:id", element: <GestionProDetailPage /> },
      { path: "zcall", element: <ZCallPage /> },
      { path: "formation", element: <FormationAppPage /> },
      { path: "formation/:id", element: <FormationDetailPage /> },
      { path: "hebergement", element: <HebergementPage /> },
      { path: "content-studio", element: <ContentStudioHomePage /> },
      { path: "content-studio/media", element: <ContentStudioMediaPage /> },
      { path: "content-studio/calendar", element: <ContentStudioCalendarPage /> },
      { path: "content-studio/series", element: <ContentStudioSeriesPage /> },
      { path: "content-studio/voice", element: <ContentStudioVoicePage /> },
      { path: "content-studio/project/:id", element: <ContentStudioProjectPage /> },
      { path: "zstudio", element: <ZStudioHomePage /> },
      { path: "zstudio/wizard", element: <ZStudioWizardPage /> },
      { path: "zstudio/creations", element: <ZStudioCreationsPage /> },
      { path: "zstudio/history", element: <ZStudioHistoryPage /> },
      { path: "zstudio/tryon", element: <ZStudioTryOnPage /> },
      { path: "zstudio/edit", element: <ZStudioEditPage /> },
      { path: "zstudio/lookbook", element: <ZStudioLookbookPage /> },
      { path: "zstudio/assistant", element: <ZStudioAssistantPage /> },
      { path: "zstudio/qr", element: <ZStudioQrPage /> },
      { path: "zstudio/projects", element: <ZStudioProjectsPage /> },
      { path: "zstudio/campaigns", element: <ZStudioCampaignsPage /> },
      { path: "marketplace", element: <MarketplaceAdminPage /> },
      { path: "*", element: <DynamicAppPage /> },
    ],
  },
  {
    path: "/developpeur",
    element: <ThemeDevPage />,
  },
  {
    path: "/developpeur/*",
    element: <ThemeDevPage />,
  },
  {
    path: "/superadmin",
    element: <SuperAdminLayout />,
    children: [
      { index: true, element: <SuperAdminDashboard /> },
      { path: "stats", element: <SuperAdminStats /> },
      { path: "users", element: <SuperAdminUsers /> },
      { path: "themes", element: <SuperAdminThemes /> },
      { path: "themes/generate", element: <ThemeGeneratePage /> },
      { path: "themes/categories", element: <ThemeCategoriesPage /> },
      { path: "themes/references", element: <ThemeReferenceFilesPage /> },
      { path: "apps", element: <SuperAdminApps /> },
      { path: "formations", element: <SuperAdminFormations /> },
      { path: "formations/:id", element: <SuperAdminFormationDetail /> },
      { path: "ai-usage", element: <SuperAdminAiUsage /> },
      { path: "apps/:id", element: <AppBuilderPage /> },
      { path: "logs", element: <SuperAdminLogs /> },
      { path: "account-types", element: <SuperAdminAccountTypes /> },
      { path: "reseaux", element: <SuperAdminReseaux /> },
      { path: "parrainage", element: <SuperAdminParrainage /> },
      { path: "plans", element: <SuperAdminPlans /> },
      { path: "subscriptions", element: <SuperAdminSubscriptions /> },
      { path: "payments", element: <SuperAdminPayments /> },
      { path: "withdrawals", element: <SuperAdminWithdrawals /> },
      { path: "commerce-payments", element: <SuperAdminCommercePayments /> },
      { path: "webhooks/feexpay", element: <FeexPayWebhookPage /> },
      { path: "core", element: <SuperAdminCore /> },
      { path: "database", element: <SuperAdminDatabase /> },
      { path: "settings", element: <SuperAdminSettings /> },
      { path: "pwa", element: <SuperAdminPwaPage /> },
      { path: "team", element: <SuperAdminTeamPage /> },
      { path: "blog", element: <SuperAdminBlogPage /> },
      { path: "activity", element: <SuperAdminActivityPage /> },
      { path: "homepage", element: <SuperAdminHomepage /> },
      { path: "temoignages", element: <SuperAdminTestimonials /> },
      { path: "storage", element: <SuperAdminStorage /> },
      { path: "rates", element: <ExchangeRatesPage /> },
      { path: "translations", element: <TranslationsPage /> },
      { path: "support", element: <SuperAdminSupport /> },
      { path: "domains", element: <SuperAdminDomains /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;